<template>
    <div v-if="referenceDesigns != null && referenceDesigns.length > 0" class="d-flex flex-column ul-light-gray-panel mb-3 refdes-pnl">
        <div class="d-flex justify-content-between align-items-stretch flex-grow-0 pl-1 ul-light-gray-panel-bottom ul-very-light-background">
            <div>Reference Designs</div>
        </div>
        <div class="d-flex flex-column pb-2 pt-2">
            <div v-for="refDesign of referenceDesigns" :key="refDesign.id" class="d-flex align-items-center ul-light-gray-panel ul-fat-light-gray-panel m-2 p-1 refdes-item">
                <div v-if="refDesign.shortDescription != ''" class="d-flex flex-column align-items-center justify-content-center part-details-ref-des-mfr">
                    <div class="text-center">{{refDesign.manufacturerName}}</div>
                    <div v-if="refDesign.hasFiles == true">
                        <div class="pr-3">
                            <span class="font-size-14 no-wrap">{{refDesign.partNumber}}</span>
                        </div>
                    </div>

                    <div v-if="refDesign.hasFiles == false" class="font-size-14">{{refDesign.partNumber}}</div>
                </div>
                <div v-if="refDesign.shortDescription != ''" class="d-flex flex-column align-items-start justify-content-center pl-2 pr-2 flex-grow-1 w-100">
                    <div class="search-result-item-description small w-100">
                        {{refDesign.shortDescription}}
                    </div>
                </div>
                <div v-if="refDesign.shortDescription == ''" class="d-flex flex-column align-items-center justify-content-center part-details-ref-des-mfr">
                    <div class="text-center">{{refDesign.manufacturerName}}</div>
                </div>
                <div v-if="refDesign.shortDescription == ''" class="d-flex flex-column align-items-start justify-content-center pl-2 pr-2 flex-grow-1 w-100">
                    <div v-if="refDesign.hasFiles == true">
                        <div class="pr-3">
                            <span class="font-size-14 no-wrap">{{refDesign.partNumber}}</span>
                        </div>
                    </div>
                    <div v-if="refDesign.hasFiles == false" class="font-size-14">{{refDesign.partNumber}}</div>
                </div>
                <div v-if="refDesign.hasFiles == true" class="mr-2 flex-shrink-0">
                    <div class="pr-3" v-show="loggedIn">
                        <a class="btn btn-dark btn-sm refdes-link internal" v-on:click.prevent="dowload(refDesign.uniqueId, refDesign.manufacturerName, refDesign.partNumber)">Download</a>
                    </div>
                    <div class="pr-3" v-show="loggedIn == false">
                        <a class="btn btn-dark btn-sm refdes-link internal" href="#" v-on:click.prevent="signIn">Sign In to Download</a>
                    </div>
                </div>
                <div v-if="refDesign.advertiserItem != null && refDesign.advertiserItem.hasExternalLink == true" class="mr-2 flex-shrink-0">
                    <a v-bind:href="refDesign.advertiserItem.externalPartLink" target="_blank" rel="nofollow" 
                       class="btn btn-light btn-sm d-flex justify-content-start align-items-center refdes-link external" v-bind:class="refDesign.advertiserItem.advertiserExternalLinkClass">
                        <span class="advertiser-panel-link-spacer" v-bind:class="refDesign.externalPartLinkCssClass"></span>
                        <span class="flex-grow-1">{{refDesign.advertiserItem.externalPartLinkText}}</span>
                        <span class="advertiser-panel-link-spacer"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'PartReferenceDesigns',
        props: {
            referenceDesigns:
            {
                type: Array,
                default: () => []
            }
        },
        methods: {
            ...mapActions('oidcStore', [
                'authenticateOidc'
            ]),
            signIn: function () {
                var configContent = JSON.parse(process.env.VUE_APP_OIDC_OPTIONS);
                var localOptions = {
                    extraQueryParams: {
                        "Base-Url": configContent.baseurl + this.$route.params.instance,
                        "App-Type": configContent.apptype,
                        "Custom-View": configContent.customView
                    }
                };
                this.authenticateOidc({ redirectPath: this.$route.path, options: localOptions });
            },
            dowload: function (uniqueId, mfrName, mfrPN) {
                this.$store.dispatch('gtmReferenceDownload', { mfrName: mfrName, mfrPN: mfrPN, cadProduct: 'Eagle' })
                this.$store.dispatch('downloadReference', uniqueId);
            }
        },
        computed: {
            ...mapGetters('oidcStore', [
                'oidcIsAuthenticated'
            ]),
            loggedIn: function () {
                return this.oidcIsAuthenticated
            }
        }
    }
</script>

<style scoped>
</style>